import * as yup from "yup";

export const voterSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Full name is required")
    .max(150, "Name must be at most 150 characters"),
  dob: yup
    .string()
    .nullable()
    .matches(/^\d{4}-\d{2}-\d{2}$/,{ message: "Date of Birth must be YYYY-MM-DD", excludeEmptyString: true })
    .optional(),
  address: yup
    .string()
    .trim()
    .max(255, "Address must be at most 255 characters")
    .optional(),
  precinct: yup
    .mixed()
    .required("Precinct is required"),
  pwd: yup.boolean().optional(),
  senior: yup.boolean().optional(),
  illiterate: yup.boolean().optional(),
});

export async function validateVoter(data) {
  try {
    const validated = await voterSchema.validate(data, { abortEarly: false });
    return { valid: true, values: validated, errors: {} };
  } catch (err) {
    const errors = {};
    if (err.inner && Array.isArray(err.inner)) {
      err.inner.forEach((e) => {
        if (e.path && !errors[e.path]) {
          errors[e.path] = e.message;
        }
      });
    } else if (err.path) {
      errors[err.path] = err.message;
    }
    return { valid: false, values: null, errors };
  }
}
